import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsHeaderSliderBlockSlideEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsHeaderSliderBlockSlideEntity
